import { Trans, useLingui } from "@lingui/react/macro";
import type { FC } from "react";

import Area from "@/components/Area.tsx";

export const TransactionAmount: FC<{
  value: number;
  profile: string | undefined;
}> = ({ value, profile }) => {
  const { i18n } = useLingui();

  if (!profile) {
    throw new Error("Service profile is required");
  } else if (profile === "https://stacspec.org") {
    if (value < 100000) {
      return (
        <span style={{ whiteSpace: "nowrap" }}>
          {i18n.number(value, { style: "unit", unit: "meter" })}
          <sup>2</sup>
        </span>
      );
    } else {
      return <Area value={value} />;
    }
  } else if (
    profile === "http://www.opengis.net/def/interface/ogcapi-features"
  ) {
    return (
      <span>
        <Trans>{i18n.number(value)} calls</Trans>
      </span>
    );
  } else if (profile === "https://api.lantmateriet.se/distribution/produkter") {
    return (
      <span>
        <Trans>{i18n.number(value)} objects</Trans>
      </span>
    );
  } else if (profile === "http://www.opengis.net/def/interface/ogcapi-tiles") {
    return (
      <span>
        <Trans>{i18n.number(value)} tiles</Trans>
      </span>
    );
  }
};
